<template>
	<PayUnlockShell v-bind="shellProps" @select="$emit('select')">
		<template #left>
			<PayIcon icon="limited" color="#fff" :bg="btnColor" :h5="h5" />
		</template>
		<template #info>
			<span v-if="data.tagText" class="g-block-pay-unlock__tag" :style="tagStyle">{{ data.tagText }}</span>
			<div class="g-block-pay-unlock__prices">
				<span class="g-block-pay-unlock__price" :style="priceColor">¥ {{ displayPrice }}</span>
				<span v-if="hasOriginalPrice" class="g-block-pay-unlock__original">¥ {{ displayOriginalPrice }}</span>
			</div>
			<p v-if="data.countdownText" class="g-block-pay-unlock__count" :style="priceColor">
				{{ data.countdownText }}
			</p>
		</template>
		<template #action>
			<PayUnlockButton
				:text="data.buttonText || '立即领取'"
				:style="buttonStyle"
				@click="onButtonClick"
			/>
		</template>
	</PayUnlockShell>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import PayUnlockButton from '../shared/PayUnlockButton.vue';
	import PayIcon from '../shared/PayIcon.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { DEFAULT_PAY_UNLOCK_LIMITED } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockLimited',
		components: { PayUnlockShell, PayUnlockButton, PayIcon },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_LIMITED;
			},
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_LIMITED);
			},
			priceColor() {
				return { color: this.btnColor };
			},
			shellProps() {
				return {
					data: this.data,
					editable: this.editable,
					active: this.active,
					fixedBottom: this.fixedBottom,
					h5: this.h5,
				};
			},
			displayPrice() {
				return formatPayPrice(this.data.price);
			},
			displayOriginalPrice() {
				return formatPayPrice(this.data.originalPrice);
			},
			hasOriginalPrice() {
				return this.data.originalPrice !== '' && this.data.originalPrice != null;
			},
			tagStyle() {
				const color = this.btnColor;
				return {
					color: color,
					background: `${color}1a`,
				};
			},
		},
	};
</script>
